import 'unfetch/polyfill/index.js';
import 'es6-promise/auto';
import anime from 'animejs';

import mq from '../utils/media-queries';
import stackHeight from '../utils/stack-height';

const controlElement = document.documentElement;
const openFlag = 'flyout-is-open';
const toggleIcon = document.getElementById('flyout-menu-toggle');
const flyoutNode = document.getElementById('main-menu-flyout');
const toggleIconAnimation = anime.timeline({
  easing: 'easeOutQuad',
  duration: 170,
  autoplay: false,
}).add({
  targets: toggleIcon.querySelector('.menu-toggle__top'),
  x1: 10,
  x2: 30,
  y1: 30,
  y2: 10,
}, 0).add({
  targets: toggleIcon.querySelector('.menu-toggle__middle'),
  x1: 10,
  x2: 30,
  y1: 10,
  y2: 30,
}, 0).add({
  targets: toggleIcon.querySelector('.menu-toggle__bottom'),
  x1: 10,
  x2: 30,
  y1: 10,
  y2: 30,
}, 0);

export default {

  _bindEvents() {
    let debouncedCompensate = _.debounce(this.compensate.bind(this), 200);
    window.addEventListener('resize', debouncedCompensate);
    window.addEventListener('popstate', debouncedCompensate.cancel);

    toggleIcon.addEventListener('click', () => this.toggle());

    document.addEventListener('keydown', (e) => {
      if ( e.key == 'Escape' ) this.close();
    });

    mq.onMinWidth('nav', () => this.close(), false);
    mq.onMaxWidth('nav', () => this.compensate());
    mq.onMinWidth('nav', () => this.uncompensate());
  },

  init() {
    this._bindEvents();
  },

  isOpen() {
    return controlElement.classList.contains(openFlag);
  },

  toggle() {
    toggleIconAnimation.play();
    toggleIconAnimation.finished.then(() => {
      toggleIconAnimation.reverse();
    });
    controlElement.classList.toggle(openFlag);
  },

  close() {
    if ( this.isOpen() ) this.toggle();
  },

  open() {
    if ( !this.isOpen() ) this.toggle();
  },

  compensate() {
    const header = document.getElementById('site-header');
    const pos = stackHeight([
      header.querySelector('.site-header__promo-bar'),
      header.querySelector('.site-header__mobile-banner'),
    ]);
    flyoutNode.style.top = `${pos}px`;
    flyoutNode.style.bottom = `${pos}px`;
  },

  uncompensate() {
    flyoutNode.style.removeProperty('top');
    flyoutNode.style.removeProperty('bottom');
  },

}

